export default __webpack_public_path__ + "static/media/ic-information.5037765f.svg";